import React from 'react';
import { motion } from 'framer-motion';
import { Overlay } from './Overlay';
import { SignalGlyph } from './SignalGlyph';
import { SignalsPdf } from './pdf/SignalsPdf';
import { signals, signalsClosing } from '../../data/signals';
import type { Format } from '../../types/snak';
interface SignalsOverlayProps {
  format: Format;
  onFormatChange: (format: Format) => void;
  onClose: () => void;
}
export function SignalsOverlay({
  format,
  onFormatChange,
  onClose
}: SignalsOverlayProps) {
  const compact = format === 'mobile';
  return <Overlay eyebrow="What we learn" format={format} onFormatChange={onFormatChange} onClose={onClose} download={{
    fileName: 'Meet-the-Filteks-What-we-learn.pdf',
    orientation: 'portrait',
    render: () => <SignalsPdf data-id="element-694" data-mp="3pddhc2ab3sfw" />
  }} data-id="element-693" data-mp="835l5jrj94f7">
      <div className={compact ? 'px-6 pb-16 pt-10' : 'mx-auto max-w-[900px] px-6 pb-24 pt-16 lg:pt-24'} data-id="element-695" data-mp="3pbkc8rfcdga0">
        <h1 className={['max-w-[20ch] font-heading leading-[1] tracking-[-0.03em] text-background', compact ? 'text-[31px]' : 'text-[42px] sm:text-[52px]'].join(' ')} data-id="element-696" data-mp="2qwro38zy4bfy">
          Every interaction creates a signal.
        </h1>

        <div className={['grid', compact ? 'mt-10 gap-7' : 'mt-16 gap-x-12 gap-y-9 sm:grid-cols-2'].join(' ')} data-id="element-697" data-mp="2gwip5nekkbwv">
          {signals.map((signal, i) => <motion.div key={signal.id} initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1 + i * 0.06,
          duration: 0.5,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex items-start gap-4" data-id="element-698" data-mp="39lg7fqis68pm" data-mpi={i}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-background ring-1 ring-[rgba(1,51,43,0.1)]" data-id="element-699" data-mp="1p7fiy234grhl">
                <SignalGlyph icon={signal.id} data-id="element-700" data-mp="1t9sqmw1fizh0" />
              </span>
              <span className="pt-0.5" data-id="element-701" data-mp="3vw7q6ypn53p2">
                <span className={['block font-heading leading-tight text-background', compact ? 'text-[15px]' : 'text-[16px]'].join(' ')} data-id="element-702" data-mp="3vv4y4ngl0v7k">
                  {signal.label}
                </span>
                <span className="mt-1.5 block max-w-[34ch] font-body text-[12.5px] leading-relaxed text-[rgba(1,51,43,0.55)]" data-id="element-703" data-mp="3h68wp9916gfx">
                  {signal.detail}
                </span>
              </span>
            </motion.div>)}
        </div>

        <p className={['border-t border-[rgba(1,51,43,0.14)] font-heading leading-[1.18] tracking-[-0.02em] text-background', compact ? 'mt-12 max-w-[26ch] pt-8 text-[20px]' : 'mt-20 max-w-[38ch] pt-10 text-[26px]'].join(' ')} data-id="element-704" data-mp="336r047phtyw0">
          {signalsClosing}
        </p>
      </div>
    </Overlay>;
}